<div class="modal-content">
  <div class="modal-header">
    <div class="row">
      <div class="col-6">
        <h4 class="modal-title"> {{'SimpleInvoice' | translate}}</h4>
      </div>
      <div class="col-6 pull-right">
        <button class="close" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-body" style="z-index: 1600; -webkit-overflow-scrolling: touch; overflow: scroll;">
    <div style="height: 600px; position: relative; overflow: scroll;">
      <table style="border-color: blue;" border="0" cellspacing="0px" width="800" cellpadding="0px">
        <tbody>
          <tr valign="top">
            <td width="40%">
              <table align="center" border="0" width="100%" id="customerPartyTable">
                <tbody>
                  <hr />
                  <tr align="left">
                    <td *ngIf="oaReqPayload.COMPANY_NAME" align="left">
                      {{ oaReqPayload.COMPANY_NAME.toUpperCase() }}<br />
                    </td>

                    <td *ngIf="!oaReqPayload.COMPANY_NAME" align="left">
                      {{ oaReqPayload.FIRST_NAME.toUpperCase()}}  {{ oaReqPayload.FAMILY_NAME.toUpperCase()  }} <br />
                    </td>
                  </tr>
                  <tr align="left">
                    <td align="left">
                      <span>
                        {{ oaReqPayload.CUSTOMERADDRESSES[0]?.DISTRICT }}
                      </span>
                      <span>
                        {{ oaReqPayload.CUSTOMERADDRESSES[0]?.STREET_NAME }}
                      </span>
                      <span>
                        {{ oaReqPayload.CUSTOMERADDRESSES[0]?.BUILDING_NAME }}
                      </span>
                      <span>No:
                        {{ oaReqPayload.CUSTOMERADDRESSES[0]?.BUILDING_NUMBER }}
                      </span>
                      <span>{{ oaReqPayload.CUSTOMERADDRESSES[0]?.ROOM }}</span>
                      <br />
                      <span>{{
                        oaReqPayload.CUSTOMERADDRESSES[0]?.CITY_SUBDIVISION_NAME
                      }}</span>
                      <span>/</span>
                      <span>{{ oaReqPayload.CUSTOMERADDRESSES[0]?.CITY }}</span>
                    </td>
                  </tr>
                  <tr align="left">
                    <td align="left">
                      <span>Tel: </span>{{ oaReqPayload.CUSTOMERADDRESSES[0]?.PHONE_NO
                      }}<span> Fax: </span>{{ oaReqPayload.CUSTOMERADDRESSES[0]?.FAX_NO
                      }}<span></span><span></span>
                    </td>
                  </tr>
                  <tr align="left">
                    <td>
                      Web Sitesi: <span></span>{{ oaReqPayload.CUSTOMERADDRESSES[0]?.WEBSITE }}
                    </td>
                  </tr>
                  <tr align="left">
                    <td>
                      E-Posta: <span></span>{{ oaReqPayload.CUSTOMERADDRESSES[0]?.EMAIL }}
                    </td>
                  </tr>
                  <tr align="left">
                    <td align="left">
                      <span>Vergi Dairesi: </span><span></span>{{ oaReqPayload.TAX_OFFICE }}<span></span>
                    </td>
                  </tr>
                  <tr align="left">
                    <td>VKN: <span></span>{{ oaReqPayload.IDENTIFIER }}</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td width="20%" align="center" valign="middle" rowspan="2">
              <img style="width: 120px;" align="middle" alt="E-Fatura Logo"
                src="./assets/images/logos/gib_logo.jpg" />
              <table *ngIf="
                  oaReqPayload.CUSTOMERFILES.ARCHIVE_FILE[1] != null &&
                  oaReqPayload.CUSTOMERFILES.ARCHIVE_FILE[1].FILE_KIND == 'IMZA'
                ">
                <tr id="Imza">
                  <td>
                    <img alt="Imza_Custom" style="max-width: 250px; max-height: 150px;" src="data:{{
                        oaReqPayload.CUSTOMERFILES.ARCHIVE_FILE[1].FILE_TYPE
                      }};base64,{{
                        oaReqPayload.CUSTOMERFILES.ARCHIVE_FILE[1].BASE64
                      }}" />
                  </td>
                </tr>
              </table>
            </td>
            <td width="40%" align="middle" valign="middle">
              <img *ngIf="
                  oaReqPayload.CUSTOMERFILES.INVOICE_FILE[0] != null &&
                  oaReqPayload.CUSTOMERFILES.INVOICE_FILE[0].FILE_KIND == 'LOGO'
                " alt="Logo" style="max-width: 250px; max-height: 150px;" src="data:{{
                  oaReqPayload.CUSTOMERFILES.INVOICE_FILE[0].FILE_TYPE
                }};base64,{{
                  oaReqPayload.CUSTOMERFILES.INVOICE_FILE[0].BASE64
                }}" />
              <img *ngIf="
                  oaReqPayload.CUSTOMERFILES.INVOICE_FILE[0] == null &&
                  oaReqPayload.CUSTOMERFILES.ARCHIVE_FILE[0] != null &&
                  oaReqPayload.CUSTOMERFILES.ARCHIVE_FILE[0].FILE_KIND == 'LOGO'
                " alt="Logo" style="max-width: 250px; max-height: 150px;" src="data:{{
                  oaReqPayload.CUSTOMERFILES.ARCHIVE_FILE[0].FILE_TYPE
                }};base64,{{
                  oaReqPayload.CUSTOMERFILES.ARCHIVE_FILE[0].BASE64
                }}" />
            </td>
            <td width="20%" align="right">
              <img src="https://qr.sovostr.com/qr?data={%22vkntckn%22:%221234567801%22,%22avkntckn%22:%221234567801%22,%22senaryo%22:%22TEMELFATURA%22,%22tip%22:%22SATIS%22,%22tarih%22:%222022-11-18%22,%22no%22:%22A502022000016958%22,%22ettn%22:%22ED678832-36B3-EEF1-810C-005056AA100E%22,%22parabirimi%22:%22TRY%22,%22malhizmettoplam%22:%22267.63%22,%22kdvmatrah(18)%22:%22267.63%22,%22hesaplanankdv(18)%22:%2248.17%22,%22vergidahil%22:%22315.8%22,%22odenecek%22:%22315.8%22}" alt="qrcode" width="175px" align="right"/>
              </td>
          </tr>
          <tr style="height: 118px;" valign="top">
            <td width="40%" align="right" valign="bottom">
              <table id="customerPartyTable" align="left" border="0" height="50%">
                <tbody>
                  <tr style="height: 71px;">
                    <td>
                      <hr />
                      <table align="center" border="0">
                        <tbody>
                          <tr>
                            <td style="width: 469px;" align="left">
                              <span style="font-weight: bold;">SAYIN</span>
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 469px;" align="left">
                              SOVOS FORİBA<br />
                            </td>
                          </tr>
                          <tr>
                            <td style="width: 469px;" align="left">
                              <span>Gold Plaza, Altayceşme Mh. Öz Sk. No: 19 Kat:
                                10</span>
                              <br /><span></span>MALTEPE<span>/ </span>İSTANBUL<span></span>
                            </td>
                          </tr>
                          <tr align="left">
                            <td>Web Sitesi: www.sovos.com</td>
                          </tr>
                          <tr align="left">
                            <td>E-Posta: info@sovos.com</td>
                          </tr>
                          <tr align="left">
                            <td style="width: 469px;" align="left">
                              <span>Tel: (0216) 445 93 79</span>
                            </td>
                          </tr>
                          <tr align="left">
                            <td>
                              <span>Vergi Dairesi: BAŞIBÜYÜK VERGİ DAİRESİ</span>
                            </td>
                          </tr>
                          <tr align="left">
                            <td>VKN: 3880718497</td>
                          </tr>
                        </tbody>
                      </table>
                      <hr />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td width="60%" align="right" valign="bottom" colspan="2">
              <table border="1" height="13" id="despatchTable">
                <tbody>
                  <tr>
                    <td style="width: 130px;" align="left">
                      <span style="font-weight: bold;">Özelleştirme No:</span>
                    </td>
                    <td align="left">TR1.2</td>
                  </tr>
                  <tr style="height: 13px;">
                    <td align="left">
                      <span style="font-weight: bold;">Senaryo:</span>
                    </td>
                    <td align="left">TEMELFATURA</td>
                  </tr>
                  <tr style="height: 13px;">
                    <td align="left">
                      <span style="font-weight: bold;">Fatura Tipi:</span>
                    </td>
                    <td align="left">SATIS</td>
                  </tr>
                  <tr style="height: 13px;">
                    <td align="left">
                      <span style="font-weight: bold;">Fatura No:</span>
                    </td>
                    <td align="left">AB02020000000001</td>
                  </tr>
                  <tr style="height: 13px;">
                    <td align="left">
                      <span style="font-weight: bold;">Fatura Tarihi:</span>
                    </td>
                    <td align="left">01-01-2001</td>
                  </tr>
                  <tr style="height: 13px;">
                    <td align="left">
                      <span style="font-weight: bold;">Fatura Saati:</span>
                    </td>
                    <td align="left">11:00:01</td>
                  </tr>
                  <tr style="height: 13px;">
                    <td align="left">
                      <span style="font-weight: bold;">Muhasebe Fatura No:</span>
                    </td>
                    <td align="left">aa11aa11-111a-11a1-a111-a11a1111a11a</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr align="left">
            <table id="ettnTable">
              <tr style="height: 13px;">
                <td align="left" valign="top">
                  <span style="font-weight: bold;">ETTN:</span>
                </td>
                <td align="left" width="240px">
                  aa11aa11-111a-11a1-a111-a11a1111a11a
                </td>
              </tr>
            </table>
          </tr>
        </tbody>
      </table>
      <div id="lineTableAligner"><span></span></div>
      <table border="1" id="lineTable" width="800">
        <tbody>
          <tr id="lineTableTr" valign="top">
            <td id="lineTableTd" style="width: 6%;">
              <span style="font-weight: bold;" align="left">Sıra No</span>
            </td>
            <td id="lineTableTd" style="width: 21%;" align="left">
              <span style="font-weight: bold;">Mal Adı</span>
            </td>
            <td id="lineTableTd" style="width: 11%;" align="right">
              <span style="font-weight: bold;">Miktar</span>
            </td>
            <td id="lineTableTd" style="width: 12%;" align="right">
              <span style="font-weight: bold;">Birim Fiyat</span>
            </td>
            <td id="lineTableTd" style="width: 16%;" align="right">
              <span style="font-weight: bold;">Net Tutar</span>
            </td>
          </tr>
          <tr id="lineTableTr" valign="top">
            <td id="lineTableTd" align="left"><span>1</span></td>
            <td id="lineTableTd" align="left">
              <span>ÖRNEK KALEM 1</span>
            </td>
            <td id="lineTableTd" align="right">
              <span>1,0<span>Adet</span></span>
            </td>
            <td id="lineTableTd" align="right"><span>1,0000TRY</span></td>
            <td id="lineTableTd" align="right"><span>1,00TRY</span></td>
          </tr>
        </tbody>
      </table>
      <div id="lineTableAligner2"><span></span></div>
      <table width="800px" border="0">
        <tr width="100%" valign="top">
          <td width="30%" align="left"></td>
          <td width="30%" valign="top">
            <table id="budgetContainerTable" width="100%">
              <tr id="budgetContainerTr" align="right" width="100%">
                <td id="budgetContainerDummyTd"></td>
              </tr>
            </table>
          </td>
          <td width="40%" valign="top" align="right">
            <table id="budgetContainerTable" width="100%">
              <tr id="budgetContainerTr" align="right" width="100%">
                <td id="budgetContainerDummyTd"></td>
                <td id="lineTableBudgetTd" align="left" width="65%">
                  <span style="font-weight: bold;">Mal Hizmet Toplam Tutarı</span>
                </td>
                <td id="lineTableBudgetTd" align="right" width="35%">
                  <span>1,00TRY</span>
                </td>
              </tr>
              <tr id="budgetContainerTr" align="right" width="100%">
                <td id="budgetContainerDummyTd"></td>
                <td id="lineTableBudgetTd" align="left" width="65%">
                  <span style="font-weight: bold;">Hesaplanan Kdv(%18,0)</span>
                </td>
                <td id="lineTableBudgetTd" align="right" width="35%">
                  0,18TRY
                </td>
              </tr>
              <tr id="budgetContainerTr" align="right">
                <td id="budgetContainerDummyTd"></td>
                <td id="lineTableBudgetTd" align="left" width="51%">
                  <span style="font-weight: bold;">Beyan Edilecek Kdv Tutarı</span>
                </td>
                <td id="lineTableBudgetTd" align="right" width="29%">
                  0,18TRY
                </td>
              </tr>
              <tr id="budgetContainerTr" align="right">
                <td id="budgetContainerDummyTd"></td>
                <td id="lineTableBudgetTd" align="left" width="51%">
                  <span style="font-weight: bold;">Vergiler Dahil Toplam Tutar</span>
                </td>
                <td id="lineTableBudgetTd" align="right" width="29%">
                  1,18TRY
                </td>
              </tr>
              <tr id="budgetContainerTr" align="right">
                <td id="budgetContainerDummyTd"></td>
                <td id="lineTableBudgetTd" align="left" width="51%">
                  <span style="font-weight: bold;">Ödenecek Tutar</span>
                </td>
                <td id="lineTableBudgetTd" width="29%">1,18TRY</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <div id="lineTableAligner3"><span></span></div>
      <table width="800px" id="notesTable">
        <tbody>
          <tr align="left" width="100%">
            <td id="notesTableTd" width="100%">
              Not...
              <b></b><br /><b></b>YALNIZ: BİR TL ONSEKİZ Kr.<br />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>